//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

import { get } from 'lodash'

export const getStartDate = state => get(state, 'salesByCategory.startDate')
export const getEndDate = state => get(state, 'salesByCategory.endDate')

